
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import React, {useContext, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import NumberInput from "../input/NumberInput";
import SelectInput from "../input/SelectInput";
import TextArea from "../input/TextArea";
import {ValidationContext} from "../contexts/ValidationContext";
import {ApiContext} from "../contexts/ApiContext";
import {useAuth} from "../../providers/authProvider";
import ExtraQuestions from "../input/ExtraQuestions";

function NewChildModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        setChildren?: any,
        children?: any,
        welcomePage: boolean,
        signUpCode?: string,
        homeVisitID?: number,
        parentEmail?: string,
        minChildAge?: number,
        maxChildAge?: number,
        childQuestions?: any,
        setChildQuestions?: any,
        locked?: boolean,
    }
) {
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)
    const {Url } = useContext(ApiContext)
    const { token } = useAuth();
    const [FirstName, setFirstName] = useState('')
    const [LastName, setLastName] = useState('')
    const [Age, setAge] = useState('')
    const [Siblings, setSiblings] = useState('')
    const [Parents, setParents] = useState('')
    const [SintSit, setSintSit] = useState('')
    const [School, setSchool] = useState('')
    const [Hobbies, setHobbies] = useState('')
    const [message, setMessage] = useState('')

    function addChild() {
        if (FirstName === '' || LastName === '' || Age === '' || Parents === '' ||  Hobbies === ''){
            setMessage('Nog niet alle verplichte velden zijn ingevuld.')
            return
        }
        if (SintSit === '' || SintSit === '0'){
            setMessage('Selecteer een optie bij "Wil dit kind op schoot bij Sinterklaas of Piet?"')
            return
        }
        if (props.welcomePage) {
            addChildWelcome()
        } else {
            addChildVisitorPage()
            //clear state data
            setFirstName('')
            setLastName('')
            setAge('')
            setSiblings('')
            setParents('')
            setSintSit('')
            setHobbies('')
            setSchool('')
            setMessage('')
            if (props.setChildQuestions){
                props.setChildQuestions((prev: any) => ({...prev, questions: prev.questions.map((q: any) => ({...q, Answer: ''}))}))
            }
        }

    }
    function addChildWelcome(){

        if (props.maxChildAge !== undefined && Number(Age) > props.maxChildAge) {
            setMessage("De leeftijd van het kind mag niet groter zijn dan " + props.maxChildAge + ".")
            return
        }
        if (props.minChildAge !== undefined && Number(Age) < props.minChildAge) {
            setMessage("De leeftijd van het kind mag niet kleiner zijn dan " + props.minChildAge + ".")
            return
        }
        let ChildID: number
        if (props.children && props.children.length > 0){
            ChildID = Math.max(...props.children.map((child: any) => child.ID), 0)
        }else{
            ChildID = 0
        }
        ChildID = ChildID + 1

        let child = {
            ID: ChildID,
            FirstName: FirstName,
            LastName: LastName,
            Age: Number(Age),
            Siblings: Siblings,
            Parents: Parents,
            SintSit: SintSit,
            School: School,
            Hobbies: Hobbies,
            Answers: props.childQuestions ? props.childQuestions.questions.map((q: any) => ({
                ...q,
                ChildQuestionID: q.ID
            })) : null,
        }
        let childrenInModal = props.children
        childrenInModal.push(child)
        if (props.setChildren) props.setChildren(childrenInModal)
        props.setOpenModal(false)
        //clear state data
        setFirstName('')
        setLastName('')
        setAge('')
        setSiblings('')
        setParents('')
        setSintSit('')
        setHobbies('')
        setSchool('')
        setMessage('')
        if (props.setChildQuestions) {
            props.setChildQuestions((prev: any) => ({...prev, questions: prev.questions.map((q: any) => ({...q, Answer: ''}))}))
        }
    }
    function addChildVisitorPage(){
        setMessage("Bezig met opslaan...")
        if (props.maxChildAge !== undefined && Number(Age) > props.maxChildAge) {
            setMessage("De leeftijd van het kind mag niet groter zijn dan " + props.maxChildAge + ".")
            return
        }
        if (props.minChildAge !== undefined && Number(Age) < props.minChildAge) {
            setMessage("De leeftijd van het kind mag niet kleiner zijn dan " + props.minChildAge + ".")
            return
        }
        fetch(Url + 'user/children', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                FirstName : FirstName,
                LastName: LastName,
                Age: Number(Age),
                Parents: Parents,
                Hobbies: Hobbies,
                Siblings: Siblings,
                SintSit: SintSit,
                School: School,
                SignUpCode: props.signUpCode,
                HomeVisitID: Number(props.homeVisitID),
                ParentEmail: props.parentEmail,
                Answers: props.childQuestions ? props.childQuestions.questions.map((q: any) => ({
                    ...q,
                    ChildQuestionID: q.ID
                })) : null,
            }),
        }).then((res: any) => {
            if (res.status === 200) {
                //Saving successfully.
                setMessage("")
                props.setOpenModal(false)
            } else {
                //Saving failed
                setMessage("Het opslaan is mislukt, neem contact op.")
            }
        })
    }
    let extraQuestions

    if (props.childQuestions && props.setChildQuestions){
        extraQuestions = (
            <ExtraQuestions
                questions={props.childQuestions.questions}
                onChange={(updated: any) => props.setChildQuestions((prev: any) => ({ ...prev, questions: updated }))}
                disabled={props.locked}
            />
        )
    }
    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title="Nieuw kind toevoegen"
            footer={
                <>
                    <DefaultButton onClick={addChild} content="Toevoegen" disabled={props.locked}/>
                    <DefaultButton onClick={() => props.setOpenModal(false)} content="Annuleren" />
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Geeft de gegevens van het kind op en klik op toevoegen. Vragen met een * zijn verplichte velden.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput labelName="Voornaam*"
                       inputName="firstName"
                       onChange={(e) => setFirstName(e.target.value)}
                       value={FirstName}
                       placeholder="Voornaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextInput labelName="Achternaam*"
                       inputName="lastName"
                       onChange={(e) => setLastName(e.target.value)}
                       value={LastName}
                       placeholder="Achternaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <NumberInput labelName="Leeftijd*"
                         inputName="age"
                         onChange={(e) => setAge(e.target.value)}
                         value={Age}
                         placeholder="Leeftijd"
                         errorMessage={"Vul hier de leeftijd van het kind in. Gebruik alleen getallen. De minimale leeftijd is: " + (props.minChildAge ?? 0) + " en de maximale leeftijd is: " + props.maxChildAge + "."}
                         max={props.maxChildAge}
                         min={props.minChildAge ?? 0}
                         step="1"
                         disabled={props.locked}
            />
            <TextInput labelName="Naam van broer(s) en/of zus(sen)"
                       inputName="siblings"
                       onChange={(e) => setSiblings(e.target.value)}
                       value={Siblings}
                       placeholder="Naam(en)"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextInput labelName="Naam van ouders en/of verzorgers*"
                       inputName="partens"
                       onChange={(e) => setParents(e.target.value)}
                       value={Parents}
                       placeholder="Naam(en)"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <SelectInput
                labelName={(FirstName ? "Wil " + FirstName : "Wil je kind") + " op schoot bij Sinterklaas of Piet?*"}
                inputName="sintSit"
                onChange={(e) => setSintSit(e.target.value)}
                value={SintSit}
                errorMessage="Selecteer een van de opties uit de lijst"
                options={
                    [
                        {
                            ID: "Ja leuk",
                            Name: "Ja leuk"
                        },
                        {
                            ID: "Ja is vorig jaar ook geweest",
                            Name: "Ja is vorig jaar ook geweest"
                        },
                        {
                            ID: "Waarschijnlijk niet",
                            Name: "Waarschijnlijk niet"
                        },
                        {
                            ID: "Geen idee",
                            Name: "Geen idee"
                        }
                    ]
                }
                disabled={props.locked}
            />
            <TextInput labelName="Naam van de school "
                       inputName="school"
                       onChange={(e) => setSchool(e.target.value)}
                       value={School}
                       placeholder="Naam van de School"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextArea labelName="Hobby's en/of sporten*"
                      inputName="hobbies"
                      onChange={(e) => setHobbies(e.target.value)}
                      value={Hobbies}
                      placeholder="Hobby's en/of sporten"
                      rows={1}
                      disabled={props.locked}
            />
            {extraQuestions}
        </BaseModal>
    );
}
export default NewChildModal
